import Mock from 'mockjs'


// 获取用户登录信息
export function list() {
    return {
        isOpen: true,
        url: '/customform/columnmeta/list',
        type: 'post',
        data: {
            "pageIndex": 1,
            "pageSize": 10,
            "rows": [{
                "canEdit": true,
                "columnName": "tradepub_code",
                "custom": false,
                "dataFormat": "C..64",
                "dataType": 0,
                "dataTypeDesc": "字符型",
                "expression": "{\"minLength\":1,\"maxLength\":64}",
                "hidden": false,
                "id": "765c31e483a7430f990d7cd5a92a7f1b",
                "itemCode": "TRADEPUBCode",
                "itemName": "其他交易公告唯一标识",
                "jsonContent": "{\"minLength\":1,\"maxLength\":64}",
                "name": "其他交易公告唯一标识",
                "openLevel": 0,
                "remark": "",
                "required": true,
                "requiredDesc": "必填",
                "ruleId": "bdfa8d9b63544a3eb542a2393f594604",
                "showInList": false,
                "single": false,
                "singleDesc": "",
                "sort": 6,
                "uniqueKey": true,
                "validType": 1,
                "validTypeDesc": "字符串",
                "valueSource": ""
            }, { "canEdit": true, "columnName": "project_name", "custom": false, "dataFormat": "C..300", "dataType": 0, "dataTypeDesc": "字符型", "expression": "{\"minLength\":1,\"maxLength\":300}", "hidden": false, "id": "0c8385051c1e423db1754d1da513fcdc", "itemCode": "PROJECT_NAME", "itemName": "项目名称", "jsonContent": "{\"minLength\":1,\"maxLength\":300}", "name": "项目名称", "openLevel": 0, "remark": "", "required": true, "requiredDesc": "必填", "ruleId": "bdfa8d9b63544a3eb542a2393f594604", "showInList": true, "single": false, "singleDesc": "", "sort": 9, "uniqueKey": false, "validType": 1, "validTypeDesc": "字符串", "valueSource": "自由文本" }, { "canEdit": true, "columnName": "trade_type", "custom": true, "dataType": 0, "dataTypeDesc": "字符型", "defaultValue": "", "expression": "{\"length\":1}", "hidden": false, "id": "6006b317c7594f34bf6979692eed12a7", "itemCode": "TRADE_TYPE", "itemName": "是否农村产权项目", "jsonContent": "{\"length\":1}", "name": "是否农村产权项目", "openLevel": 0, "patternRegex": "", "required": true, "requiredDesc": "必填", "ruleId": "bdfa8d9b63544a3eb542a2393f594604", "showInList": true, "single": false, "singleDesc": "", "sort": 10, "uniqueKey": false, "validType": 1, "validTypeDesc": "字符串" }, { "canEdit": true, "columnName": "estimate_price", "custom": false, "dataFormat": "N..20,6", "dataType": 4, "dataTypeDesc": "数值型", "expression": "^([1-9]{1}\\d*|0)(\\.\\d{1,6})?$", "hidden": false, "id": "76f56102247a6c315890546300a145c4", "itemCode": "ESTIMATE_PRICE", "itemName": "预估价", "name": "预估价", "openLevel": 0, "patternRegex": "^([1-9]{1}\\d*|0)(\\.\\d{1,6})?$", "remark": "", "required": true, "requiredDesc": "必填", "ruleId": "bdfa8d9b63544a3eb542a2393f594604", "showInList": false, "single": false, "singleDesc": "", "sort": 10, "uniqueKey": false, "validType": 99, "validTypeDesc": "正则表达式", "valueSource": "" }, { "canEdit": true, "columnName": "tender_mode", "custom": false, "dataFormat": "C4", "dataType": 0, "dataTypeDesc": "字符型", "hidden": false, "id": "a16873379115ae7fb0f78e6ab1d10d81", "itemCode": "TENDER_MODE", "itemName": "交易方式", "name": "交易方式", "openLevel": 0, "patternRegex": "{\"length\":4}", "remark": "", "required": true, "requiredDesc": "必填", "ruleId": "bdfa8d9b63544a3eb542a2393f594604", "showInList": false, "single": false, "singleDesc": "", "sort": 10, "uniqueKey": false, "validType": 1, "validTypeDesc": "字符串", "valueSource": "竞价:Q001;挂牌:Q002;拍卖:Q003;协议转让:Q004;其他:Q005;" }, { "canEdit": true, "columnName": "project_code", "custom": false, "dataFormat": "C..20", "dataType": 0, "dataTypeDesc": "字符型", "expression": "{\"minLength\":1,\"maxLength\":20}", "hidden": false, "id": "20a2a87d8c3b4e7282b94b222beee0d1", "itemCode": "PROJECT_CODE", "itemName": "项目编号", "jsonContent": "{\"minLength\":1,\"maxLength\":20}", "name": "项目编号", "openLevel": 0, "remark": "", "required": true, "requiredDesc": "必填", "ruleId": "bdfa8d9b63544a3eb542a2393f594604", "showInList": true, "single": false, "singleDesc": "", "sort": 12, "uniqueKey": false, "validType": 1, "validTypeDesc": "字符串", "valueSource": "" }, { "canEdit": true, "columnName": "publishing_time", "custom": false, "dataFormat": "yyyyMMddHHmmss", "dataType": 1, "dataTypeDesc": "日期时间型", "expression": "^[1-2]\\d{3}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01])(0[1-9]|1\\d|2[0-3])(0[1-9]|[1-5]\\d){2}$", "hidden": false, "id": "4a271a70e95c49909c4e79c186434294", "itemCode": "PUBLISHING_TIME", "itemName": "公告发布时间", "name": "公告发布时间", "openLevel": 0, "patternRegex": "^[1-2]\\d{3}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01])(0[1-9]|1\\d|2[0-3])(0[1-9]|[1-5]\\d){2}$", "remark": "", "required": false, "requiredDesc": "", "ruleId": "bdfa8d9b63544a3eb542a2393f594604", "showInList": true, "single": false, "singleDesc": "", "sort": 15, "uniqueKey": false, "validType": 99, "validTypeDesc": "正则表达式", "valueSource": "" }, { "canEdit": true, "columnName": "unified_deal_code", "custom": false, "dataFormat": "C40", "dataType": 0, "dataTypeDesc": "字符型", "expression": "{\"length\":40}", "hidden": false, "id": "7984fa12e8954aea8a7fc83d13685301", "itemCode": "UNIFIED_DEAL_CODE", "itemName": "统一交易标识码", "jsonContent": "{\"length\":40}", "name": "统一交易标识码", "openLevel": 0, "remark": "", "required": false, "requiredDesc": "", "ruleId": "bdfa8d9b63544a3eb542a2393f594604", "showInList": true, "single": false, "singleDesc": "", "sort": 18, "uniqueKey": false, "validType": 1, "validTypeDesc": "字符串", "valueSource": "参考1.3统一交易标识码编码方案" }, { "canEdit": true, "columnName": "region_code", "custom": false, "dataFormat": "C6", "dataType": 0, "dataTypeDesc": "字符型", "expression": "{\"length\":6}", "hidden": false, "id": "19cea5be5e404965a628dabe64ffb2ac", "itemCode": "REGION_CODE", "itemName": "项目所在行政区域代码", "jsonContent": "{\"length\":6}", "name": "项目所在行政区域代码", "openLevel": 0, "remark": "", "required": true, "requiredDesc": "必填", "ruleId": "bdfa8d9b63544a3eb542a2393f594604", "showInList": true, "single": false, "singleDesc": "", "sort": 21, "uniqueKey": false, "validType": 1, "validTypeDesc": "字符串", "valueSource": "采用GB/T 2260-2007《中华人民共和国行政区划代码》" }, {
                "canEdit": true,
                "columnName": "region_full_code",
                "custom": false,
                "dataFormat": "C9",
                "dataType": 0,
                "dataTypeDesc": "字符型",
                "expression": "{\"minLength\":1,\"maxLength\":200}",
                "hidden": false,
                "id": "ad900ce426a3328e418e4e89c76dfe4d",
                "itemCode": "regionFullCode",
                "itemName": "项目所在行政区域代码扩展",
                "jsonContent": "{\"minLength\":1,\"maxLength\":200}",
                "name": "项目所在行政区域代码扩展",
                "openLevel": 0,
                "remark": "",
                "required": false,
                "requiredDesc": "",
                "ruleId": "bdfa8d9b63544a3eb542a2393f594604",
                "showInList": true,
                "single": false,
                "singleDesc": "",
                "sort": 22,
                "uniqueKey": false,
                "validType": 1,
                "validTypeDesc": "字符串",
                "valueSource": "采用GB/T 2260-2007《中华人民共和国行政区划代码》"
            }],
            "total": 25,
            "totalItemCount": 25,
            "totalPageCount": 3
        }
    }
}


export function savetablemetaData() {
    return {
        //isOpen: false,
        url: '/customform/columnmeta/save',
        type: 'post',
        data: {
            'msg': 'success',
            'code': "1",
        }
    }
}

export function gettablemetaData() {
    return {
        //isOpen: false,
        url: '/customform/columnmeta/get',
        type: 'get',
        data: {
            'msg': 'success',
            'code': "1",
            'data': {
                "createTime": "2019-08-26 15:22:00",
                "id": "bdfa8d9b63544a3eb542a2393f594604",
                "displayName": "其他交易公告信息",
                "datasetCode": "Q01",
                "sort": 18,
                "status": 0,
                "tableName": "qtjy_other_trade_pub_info",
                "uniqueNames": "其他交易公告唯一标识",
                "updateTime": "2019-09-18 16:41:59",
                "updateUser": "0"
            }
        }
    }
}